import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ItemRemarks from '../ProfileCaseListItem/ItemRemarks'
import OpenForm from '../ProfileCaseListItem/OpenForm'
import caretRight from '../../icons/caret-right_light_gray.svg'
import caretRightActive from '../../icons/caret-right_gray.svg'
import { setActiveConnection } from '../../redux/actions'
import {
  getActiveConnection,
  hasConfirmedRelationProffSelection,
} from '../../redux/selectors'
import { getActiveConnectionDataFromClickedListItem } from '../ConnectionForm/utils'
import {
  RELATION,
  USER_OWNERSHIP,
  RELATION_OWNERSHIP,
  USER_ROLE,
  RELATION_ROLE,
  USER_OTHER_CONNECTION,
  RELATION_OTHER_CONNECTION,
} from '../../connectionTypes'
import CaseInfo from './CaseInfo'

const SelectedCase = ({
  Case,
  setActiveConnection,
  unsetActiveConnection,
  active,
  disabledInteraction,
  relation,
  hasConfirmedProffSelection,
  connectionType
}) => {

  const checked = connectionType == RELATION
    ? hasConfirmedProffSelection
    : [
      USER_OWNERSHIP,
      RELATION_OWNERSHIP,
      USER_ROLE,
      RELATION_ROLE,
      USER_OTHER_CONNECTION,
      RELATION_OTHER_CONNECTION
    ].includes(connectionType)

  const onClick = (e) => {
    const activeConnectionData = getActiveConnectionDataFromClickedListItem(
      Case,
      relation,
    )

    unsetActiveConnection()
    active
      ? unsetActiveConnection()
      : setActiveConnection({
        id: activeConnectionData.id,
        caseId: relation ? undefined : Case?.id,
        relationId: Case?.relationId,
        connectionType: connectionType,
        connection: activeConnectionData,
      })
  }

  return (
    Case && (
      <Wrapper>
        <CaseInfo Case={Case} connectionType={connectionType} />
        <Status
          className={[active && 'active', !checked && 'attention']}
          onClick={onClick}>
          <ItemRemarks Case={Case} confirmed={checked} />
          <OpenForm checked={checked} onClick={onClick} />
          <CaretRight src={active ? caretRightActive : caretRight} />
        </Status>
      </Wrapper>
    )
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  gap: 2em;
`

const Status = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto; 
  margin-right: 0;
  border-radius: 5px;
  padding: 1em;

  cursor: pointer;
  &:hover {
    background-color: #e9e9e9;
  }
  &.active {
    background-color: #e9e9e9;
  }
`

const CaretRight = styled.img`
  height: 1.5em;
  width: 1.5em;
`

const mapStateToProps = (state, props) => {
  const activeConnection = getActiveConnection(state)
  const active = ((props.Case?.caseType !== RELATION && activeConnection?.caseId === props.Case?.id)
    || (props.Case?.relationType && activeConnection?.id === props.Case?.id))

  const relation = props.Case?.relationType ? props.Case : null
  const hasConfirmedProffSelection = relation?.id ? hasConfirmedRelationProffSelection(state, relation.id) : false

  return {
    active: active,
    relation: relation,
    hasConfirmedProffSelection: hasConfirmedProffSelection
  }
}

const mapDispatchToProps = { setActiveConnection }

export default connect(mapStateToProps, mapDispatchToProps)(SelectedCase)